import { initializeApp } from "firebase/app";
import {
    getAuth,
    setPersistence,
    browserLocalPersistence,
} from "firebase/auth";
import {
    initializeFirestore,
    collection,
    addDoc,
    serverTimestamp,
} from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAnalytics, isSupported as analyticsIsSupported } from "firebase/analytics";

// `authDomain` muss auf derselben Origin wie die App laufen, sonst
// scheitert der OAuth-Redirect-Login auf iOS Safari (Cross-Origin-iFrame
// wird von ITP geblockt → User kommt zurück, ist aber nicht eingeloggt).
//
// Voraussetzung: Alle hier genannten Domains sind sowohl in der Firebase
// Console (Authentication → Settings → Authorized domains) als auch im
// Google Cloud OAuth-Client (Authorized JavaScript origins +
// Authorized redirect URIs `https://<host>/__/auth/handler`) freigeschaltet.
const SUPPORTED_AUTH_HOSTS = new Set([
    "pinkcatai.com",
    "www.pinkcatai.com",
    "pinkcatai.web.app",
    "pinkcatai.firebaseapp.com",
]);

const resolveAuthDomain = () => {
    if (typeof window === "undefined") return "pinkcatai.firebaseapp.com";
    const host = window.location.hostname;
    if (SUPPORTED_AUTH_HOSTS.has(host)) return host;
    return "pinkcatai.firebaseapp.com";
};

const firebaseConfig = {
    apiKey: "AIzaSyC_hxgONbDNJTjQGrtnamBMUGFslZI8gNA",
    authDomain: resolveAuthDomain(),
    projectId: "pinkcatai",
    storageBucket: "pinkcatai.firebasestorage.app",
    messagingSenderId: "777810507452",
    appId: "1:777810507452:web:afbf6158a1719225de82b9",
    measurementId: "G-GLGZ4T5DBQ"
};

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
// Explizite Persistenz: ohne das fällt Firebase auf manchen Mobile-Browsern
// nach dem Redirect auf In-Memory zurück und der Login-State geht verloren.
setPersistence(auth, browserLocalPersistence).catch((err) => {
    console.warn("Firebase auth persistence init failed:", err?.message || err);
});

// `experimentalAutoDetectLongPolling` löst „Fetch API cannot load ...Listen/channel
// ... due to access control checks" — passiert auf Safari/iOS, hinter Tracking-
// Schutz/Adblockern oder restriktiven Firmen-Netzwerken, weil Firestores
// WebChannel-Streaming blockiert wird. Mit autoDetect fällt der SDK zur Laufzeit
// automatisch auf Long-Polling zurück, sobald das Streaming nicht durchkommt.
const firestore = initializeFirestore(app, {
    experimentalAutoDetectLongPolling: true,
});
const storage = getStorage(app);

analyticsIsSupported()
    .then((supported) => {
        if (supported) getAnalytics(app);
    })
    .catch(() => {});

export { auth, firestore, storage, collection, addDoc, serverTimestamp };
